import { UserStatusType } from '../../types';
import { useLocaleStore } from '../../stores/localeStore';

export const STATUS_PRESENTATION: Record<UserStatusType, {
  emoji: string;
  label: string;
  cardClass: string;
  accentClass: string;
}> = {
  [UserStatusType.MESSAGE]: {
    emoji: '📝',
    label: 'Message',
    cardClass: 'border-cyan-500/20 bg-cyan-500/[0.07]',
    accentClass: 'text-cyan-600 dark:text-cyan-300',
  },
  [UserStatusType.EVENT]: {
    emoji: '🎉',
    label: 'Event',
    cardClass: 'border-emerald-500/20 bg-emerald-500/[0.07]',
    accentClass: 'text-emerald-600 dark:text-emerald-300',
  },
  [UserStatusType.ANNOUNCEMENT]: {
    emoji: '📢',
    label: 'Announcement',
    cardClass: 'border-amber-500/20 bg-amber-500/[0.07]',
    accentClass: 'text-amber-600 dark:text-amber-300',
  },
  [UserStatusType.PARTY]: {
    emoji: '🎊',
    label: 'Party',
    cardClass: 'border-violet-500/20 bg-violet-500/[0.07]',
    accentClass: 'text-violet-600 dark:text-violet-300',
  },
};

export function formatRelativeDate(dateInput: string | Date | undefined): string {
  if (!dateInput) return 'Unknown date';
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return 'Unknown date';

  const minutes = Math.floor((Date.now() - date.getTime()) / 60_000);
  if (minutes < 0) return date.toLocaleDateString(useLocaleStore.getState().locale);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (minutes < 1_440) return `${Math.floor(minutes / 60)}h ago`;
  if (minutes < 10_080) return `${Math.floor(minutes / 1_440)}d ago`;
  return date.toLocaleDateString(useLocaleStore.getState().locale);
}

export function formatLocaleDateTime(dateInput: string | Date): string {
  return new Date(dateInput).toLocaleString(useLocaleStore.getState().locale);
}
